import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../global-config'
import { NextLink } from '../../../../next-link'
import { urlResolverGetPathForPimProduct } from '../../../../url-handling'
import { type SelectionEntry } from '../../product-page-context/AttributeGroup'
import { useProductPageRebrushStyle } from '../../product-page-context/useProductPageRebrushStyle'
import { useProductPageContext } from '../../productPageContext'

type ProductPageVariantWrapperProps = {
  candidateVariant: PimProductV11
  isVariantSelected: boolean
  selectionEntry: SelectionEntry
}

export const ProductPageVariantWrapper: FC<
  PropsWithChildren<ProductPageVariantWrapperProps>
> = ({ candidateVariant, children, isVariantSelected, selectionEntry }) => {
  const { attributeSelectionControls } = useProductPageContext()
  const globalConfig = useGlobalConfigContext()
  const isRebrushStyle = useProductPageRebrushStyle()

  const wrapperClassNames = clsx(
    'flex min-h-[5.5rem] w-full items-center',
    !isRebrushStyle && 'py-2',
    isRebrushStyle &&
      'rounded-2xl border border-dark-primary-strong bg-light-primary-low p-2 mobile:p-3.5 desktop:min-h-20',
  )

  if (isVariantSelected) {
    return <div className={wrapperClassNames}>{children}</div>
  }

  return (
    <NextLink
      className={clsx('text-dark-primary-strong', wrapperClassNames)}
      data-qa-id="product-variant"
      href={urlResolverGetPathForPimProduct(globalConfig, candidateVariant)}
      onClick={(): void => {
        attributeSelectionControls.handleAttributeSelect(selectionEntry)
      }}
      scroll={false}
    >
      {children}
    </NextLink>
  )
}
